export default {
  data() {
    return {
      columns: [
        {
          title: '文件名称',
          dataIndex: 'name',
          disabled: true,
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          disabled: true,
        },
        {
          title: '操作',
          fixed: 'right',
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
